export const MAIL_REQUEST_DISPATCH = (state) => {
  state.status = 'requested';
};

export const MAIL_REQUEST_SUCCESS = (state) => {
  state.status = 'success';
};

export const MAIL_REQUEST_ERROR = (state) => {
  state.status = 'error';
};

export const SAVE_LIST = (state, val) => {
  state.list = val;
}

export const SAVE_STATUSES = (state, val) => {
  state.list = {...state.list, ...val};
}

export const ADD_MORE_MAILS = (state, val) => {
  state.more = [...state.more, ...val];
}

export const CLEAR_MORE_MAILS = (state) => {
  state.more = [];
}

export const UPDATE_ACTION_MAIL = (state, val) => {
  state.actionMail = val;
}

export const SAVE_REMINDERS = (state, val) => {
  state.reminders = val;
}